import { FormControl, MenuItem, FormHelperText } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getNewsCategories } from '../../fetch';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';

interface INewsCategoryDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
}

export const NewsCategoryDropdown: FC<INewsCategoryDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  message,
  hasError
}) => {
  const { isLoading, data } = useQuery<IDropdownResponse[], Error>(['getNewsCategories'], () =>
    getNewsCategories()
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired} error={hasError}>
      <SMBSelect
        disabled={isDisabled || isLoading}
        name={`county`}
        label={isLoading ? 'Loading...' : 'Category'}
        id={`county`}
        value={value}
        variant="outlined"
        handleClear={() => handleChange('')}
        onChange={({ target: { value } }) => {
          handleChange(value as string);
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
      >
        {!isLoading && data && data.length === 0 && <MenuItem disabled>No data available</MenuItem>}
        {!isLoading &&
          data &&
          data.map((d, index) => {
            return (
              <MenuItem key={d.value} value={d.value}>
                {d.description}
              </MenuItem>
            );
          })}
      </SMBSelect>
      {message && <FormHelperText error>{message}</FormHelperText>}
    </FormControl>
  );
};
